import { createIcon } from '@chakra-ui/react';

export const ArrowLeft = createIcon({
  displayName: 'ArrowLeft',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M15 5L8 11.9815L15 19"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
    />
  ),
});
